import React, { FC } from 'react'
import Typography from '../../typography'

type Props = {
  listingTitle: string
  isMainBlog: boolean
  disableListingTitle: boolean
  microcopyTextListingTitle: string
}

export const FirstPage: FC<Props> = ({
  listingTitle,
  isMainBlog,
  disableListingTitle,
  microcopyTextListingTitle,
}) => (
  <>
    {listingTitle && (
      <Typography
        className={`BlogListingContainer-Header ${
          !isMainBlog ? 'BlogListingContainer-Header--SecondaryBlog' : ''
        }`}
        type="header3">
        {listingTitle}
      </Typography>
    )}

    {!disableListingTitle && (
      <Typography className="BlogListingContainer-Header" type="header4">
        {!microcopyTextListingTitle ? microcopyTextListingTitle : 'Latest Articles'}
      </Typography>
    )}
  </>
)
